var acc = document.getElementsByClassName('js-accordion');
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
        } else {
            panel.style.display = 'block';
        }
    });
}
function toggleCta() {
    stickyCta.classList.toggle('sticky-cta--open');
}

var stickyCtaSpan = document.querySelector('.sticky-cta span');
var stickyCta = document.querySelector('.sticky-cta');

if (stickyCtaSpan) {
    stickyCtaSpan.addEventListener('click', toggleCta);
}

let stickyFooter = document.querySelector('.course-sidebar__inner');
if (stickyFooter) {
    let jsCourseButtons = document.querySelectorAll('.course-sidebar__inner .button');
    let jsButtonsTarget = document.querySelector('.sticky-buttons-course .buttons');

    if (jsButtonsTarget) {
        jsCourseButtons.forEach(function (elem) {
            let clone = elem.cloneNode(true);
            jsButtonsTarget.before(clone);
        });
    }
}